import React, { Component } from 'react';
import axios from 'axios';
import '../../Asset/Css/Site.css';
import { FetchAssignment } from './FetchAssignment'
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import global from '../global'
import moment from 'moment';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { Layout } from '../Layout';
import download from 'downloadjs'
import Spinner from '../Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import { config } from '../../Constants';

export class AddEditAssignment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            assignmentID: 0,
            assignmentName: '',
            assignmentCode: '',
            remitterName: '',
            remitterID: -1,
            RemitterCode: '',
            token: '',
            remitters: [],
            FYIDs: [],
            FYID: 0,
            isSearchable: true,
            file: '',
            filesToBeSent: '',
            URL: '',
            formErrors: '',
            AssignmentData: FetchAssignment,
            previousYear: '',
            loading: false,
            Title: 'Assignment Creation',
            ButtonText: 'CREATE',
            IsDisable: false,
            chkDigitalSign: false,
            chkManualSign: false,
            chkConsent: false,

        };

        this.initialState = this.state;

        const parsed = queryString.parse(window.location.search);
        var Id = parsed['ACE'] == undefined ? 0 : window.atob(parsed['ACE']);
        var ReqType = parsed['Type'] == undefined ? 'A' : window.atob(parsed['Type']);
        this.setState({ assignmentCode: Id });
        this.state.assignmentCode = Id;

        if (ReqType == 'A') {
            this.state.Title = 'Assignment Creation';
            this.state.ButtonText = 'CREATE';
            this.state.IsDisable = false;
        }
        else {
            this.state.Title = 'Modify Assignment Details';
            this.state.ButtonText = 'UPDATE';
            this.state.IsDisable = true;
        }
       
        // This will set state for Edit 
        if (Id != 0) {
            this.state.loading = true;
            axios.get(global.Assignment.GetIdWiseDetailsAPI + Id,
                { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                .then(response => {
                    this.setState({
                        assignmentCode: response.data[0]["AssignmentCode"],
                        assignmentID: response.data[0]["AssignmentID"],
                        assignmentName: response.data[0]["AssignmentName"],
                        FYID: response.data[0]["FYID"],
                        remitterID: response.data[0]["RemitterID"],
                        remitterName: response.data[0]["RemitterName"],
                        previousYear: response.data[0]["PreviousYear"],
                        chkDigitalSign: response.data[0]["IsESign"],
                        chkManualSign: response.data[0]["IsManualSign"],
                        chkConsent: response.data[0]["IsConsent"],
                        formErrors: true
                    });

                })
                .catch(function (error) {
                    console.log(error);
                })
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.state.loading = false;
    }

    handleFormValidation = (e) => {
        const { assignmentName, remitterID } = this.state;
        let formErrors = {};
        let formIsValid = true;

        //Assignment name
        if (!assignmentName) {
            formIsValid = false;
            formErrors["assignmentNameErr"] = "Assignment Name is required.";
        }

        if (remitterID == '') {
            formIsValid = false;
            formErrors["RemitterErr"] = "Please select Remitter.";
        }

        formIsValid = false;

        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.setState({ formErrors: formErrors });

        return formIsValid;
    }

    handleChange = (e) => {
        let formErrors = {};
        let formIsValid = true;
        if (e.value == '') {
            formIsValid = false;
            formErrors["FYIDErr"] = "Please select Financial year.";
        }
        this.setState({ FYID: e.value });
        this.setState({ formErrors: formErrors });
        this.setState({ previousYear: e.value });
        return formIsValid;
    }

    handlePChange(e) {
        let formErrors = {};
        let formIsValid = true;
        if (e.value == '') {
            formIsValid = false;
            formErrors["FYIDErr"] = "Please select Previous Financial year.";
        }
        this.setState({ formErrors: formErrors });
        this.setState({ previousYear: e.value });
        return formIsValid;
    }

    componentDidMount() {

        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        RemitterCode: response.data.RemitterCode,
                        token: response.data.JwtToken,
                        URL: config.url.Web_URL
                    });
                } else {
                    window.location.href = config.url.Web_URL + `/Error/404`;
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get(global.Form15GH.GetDetailsDDLAPI,
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
            .then(response => {

                const optionsFYID = response.data.fyid.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))

                const optionsRemitter = response.data.Remitter.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))
                this.setState({ FYIDs: optionsFYID, remitters: optionsRemitter })

            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSampleDownload = (e) => {
        this.setState({ loading: true });
        axios.get(global.Assignment.DownloadSampleAPI,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/xlsx' },
                responseType: 'blob'
            })
            .then(response => {
                this.setState({ loading: false });
                this.showNoti("Notification", "File Downloaded Successfully", "success");

                const content = response.headers['content-type'];
                const fileName = "Sample Template.xlsx"
                download(response.data, fileName, content)
            })
            .catch(error => {
                this.setState({ loading: false });
                console.log(error);
                this.showNoti("Notification", "Error Occurred While Downloading Template", "danger");

            });
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    handleCancel = (e) => {
        e.preventDefault();

        window.location.href = this.state.URL + `/Nexdigm/Assignment`;

    }

    handleSubmit = (e) => {
        debugger
        e.preventDefault();

        if (this.state.assignmentName == "" || this.state.assignmentName == null) {
            this.showNoti("Notification", "Assignment Name is required.", "danger");
            return;
        }

        if (this.state.remitterID == -1 || this.state.remitterID == "" || this.state.remitterID == null) {
            this.showNoti("Notification", "Remitter is required.", "danger");
            return;
        }

        if (this.state.FYID == 0 || this.state.FYID == "" || this.state.FYID == null) {
            this.showNoti("Notification", "Financial Year is required.", "danger");
            return;
        }

        if (this.state.previousYear == 0 || this.state.previousYear == "" || this.state.previousYear == null) {
            this.showNoti("Notification", "Previous Year is required.", "danger");
            return;
        }

        if (this.state.filesToBeSent == "") {
            this.showNoti("Notification", "Template File is not chosen.", "danger");
            return;
        }

        if (this.state.chkDigitalSign == false && this.state.chkManualSign == false && this.state.chkConsent == false) {
            this.showNoti("Notification", "Atleast one check is required", "danger");
            return;
        }

        this.setState({ loading: true });
        this.state.Flag = 'I';
        this.state.IsActive = 1;

        const demoAssignment = this.state;

        axios.post(global.Assignment.IAssignmentAPI, demoAssignment,
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
            .then(json => {

                if (json.data.status) {

                    this.state.assignmentCode = json.data.AssignmentCode;
                    this.state.remitterName = json.data.RemitterName;

                    if (this.state.filesToBeSent) {
                        var filesArray = this.state.filesToBeSent;
                        let form = new FormData();
                        form.append("File", filesArray);
                        form.append("fileName", filesArray.name);
                        form.append("assignmentCode", this.state.assignmentCode);
                        form.append("remitterName", this.state.remitterName);
                        axios.post(global.Assignment.UploadFileAPI, form,
                            {
                                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/xlsx' },
                                responseType: 'blob'
                            })
                            .then(response => {
                                if (response) {

                                    this.showNoti("Notification", global.Message.SuccessMessage, "success");

                                    const content = response.headers['content-type'];
                                    const fileName = "Log.xlsx";

                                    download(response.data, fileName, content);

                                    this.setState({ loading: false });

                                    window.location.href = this.state.URL + `/Nexdigm/Assignment`;
                                }
                                else {
                                    this.showNoti("Notification", global.Message.FileInvalidMessage, "danger");
                                    this.setState({ loading: false });
                                }
                            });
                    }
                    else {
                        this.showNoti("Notification", global.Message.SuccessMessage, "success");

                        this.setState(this.initialState)
                        this.setState({ loading: false });
                        window.location.href = this.state.URL + `/Nexdigm/Assignment`;
                    }
                }
                else {
                    this.setState({ loading: false });
                    this.showNoti("Notification", "Assignment Name Already Exists.", "danger");
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                this.showNoti("Notification", "Assignment Name Already Exists.", "danger");
            });
       
    }

    FormValidation() {
        debugger
        let isValid = true
        if (this.state.remitterID == -1) {
            isValid = false
        } else if (this.state.assignmentName == '') {
            isValid = false;
        } else if (this.state.previousYear == 0) isValid = false;
        else if (this.state.FYID == 0) isValid = false;
        else if (this.state.filesToBeSent == "") {
            isValid = false;
        }

        return isValid;
    }

    handleRemitter(e) {
        debugger
        let formErrors = {};
        let formIsValid = true;
        if (e.value == '') {
            formIsValid = false;
            formErrors["RemitterErr"] = "Please select Remitter.";
        }
        this.setState({ remitterID: e.value });
        this.setState({ formErrors: formErrors });

    }


    handelFileChange = event => {
        // Update the state 
        debugger
        let file = event.target.files[0];
        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "xlsx" || type == "xls") {
            this.setState({ filesToBeSent: event.target.files[0] });
        }
        else {
            this.showNoti("Notification", global.Message.FormatRequiredMessage, "danger");
        }

    };
    handleNumericChange = (e) => {
        const { name, value } = e.target;

        if (value.length <= 4 && !isNaN(Number(value)) && [name] == "previousYear") {
            this.setState({ [name]: value });
        }
    }

    toggleChangeDS = () => {
        this.setState({
            chkDigitalSign: !this.state.chkDigitalSign,
        });

        console.log(this.state.chkDigitalSign);
    }

    toggleChangeMS = () => {
        this.setState({
            chkManualSign: !this.state.chkManualSign,
        });
        console.log(this.state.chkManualSign);

    }

    toggleChangeConsent = () => {
        this.setState({
            chkConsent: !this.state.chkConsent,
        });
        console.log(this.state.chkConsent);

    }

    render() {
        if (this.state.loading) return <Spinner />;
        let content = Layout.RenderNavMenu()
        const { assignmentNameErr, FYIDErr, RemitterErr } = this.state.formErrors;
        const {
            isSearchable
        } = this.state;
        return (
            <div>
                <ReactNotification />
                {content}
                <div className="Nexdigm">
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><a href={this.state.URL + "/Nexdigm/Dashboard" } className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a href={this.state.URL + "/Nexdigm/Assignment"} className="text-white">Assignments</a></li>
                        <li><a className="text-white">{this.state.Title}</a></li>

                    </ol>
                </div>

                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <Row>
                                <Col md={4}>
                                    <h4 className="header-title">{this.state.Title}</h4>
                                </Col>
                                <Col md={8} >
                                    <button className="btn btn-info m-l-10 pull-right" onClick={this.handleSampleDownload}> <FontAwesomeIcon icon="cloud-download-alt" /> Download Shareholder Template  </button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <label className="required-field">Assignment Name</label>
                                    <FormControl type="text" name="assignmentName" key="txtAssignmentName" className="m-t-10" maxLength="100"
                                        value={this.state.assignmentName}
                                        placeholder="Assignment Name"
                                        onChange={this.handleFormValidation}
                                        disabled={this.state.IsDisable}
                                    />
                                </Col>
                                <Col md={6} className="m-t-20">
                                    <label className="required-field">Remitter</label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select Remitter"
                                        placeholder="Select Remitter"
                                        value={this.state.remitters.find(obj => obj.value === this.state.remitterID)}
                                        isSearchable={isSearchable}
                                        options={this.state.remitters}
                                        onChange={this.handleRemitter.bind(this)}
                                        isDisabled={this.state.IsDisable}
                                        className= {RemitterErr ? ' showError' : ''}
                                    />
                                </Col>
                               
                                <Col md={3} className="m-t-20">
                                    <label className="required-field">Financial Year</label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select financial year"
                                        placeholder="Select FY"
                                        value={this.state.FYIDs.find(obj => obj.value === this.state.FYID)}
                                        onChange={this.handleChange.bind(this)}
                                        className={FYIDErr ? ' showError' : ''}
                                        isDisabled={this.state.IsDisable}
                                        options={this.state.FYIDs}
                                    />
                                </Col>
                                <Col md={3} className="m-t-20">
                                    <label className="required-field">Previous Year</label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select previous year"
                                        placeholder="Select FY"
                                        value={this.state.FYIDs.find(obj => obj.value === this.state.previousYear)}
                                        onChange={this.handlePChange.bind(this)}
                                        className={FYIDErr ? ' showError' : ''}
                                        isDisabled={this.state.IsDisable}
                                        options={this.state.FYIDs}                                        
                                    />
                                </Col>
                                


                                <Col md={12} className="m-t-20">
                                    <input
                                        type="checkbox"
                                        //id="chk_ds"
                                        //name="chkDigitalSign"
                                        //value="DigitalSign"
                                        checked={this.state.chkDigitalSign}
                                        onChange={this.toggleChangeDS.bind(this)}
                                    /><span> </span>
                                    <label> Digital Sign </label>
                                    
                                </Col>
                                <Col md={12} className="m-t-20">
                                    <input
                                        type="checkbox"
                                        //id="chk_ms"
                                        //name="chkManualSign"
                                        //value="ManualSign"
                                        checked={this.state.chkManualSign}
                                        onChange={this.toggleChangeMS.bind(this)}
                                    /><span> </span>
                                    <label> Manual Sign </label>

                                </Col>
                                <Col md={12} className="m-t-20">
                                    <input
                                        type="checkbox"
                                        //id="chk_consent"
                                        //name="chkConsent"
                                        //value="Consent"
                                        checked={this.state.chkConsent}
                                        onChange={this.toggleChangeConsent.bind(this)}
                                    /><span> </span>
                                    <label> Consent </label>
                                </Col>


                                <Col md={12} className="m-t-20">
                                    <label className="required-field" htmlFor="file">Upload Shareholder Template</label>
                                    <input type="file" name="files" onChange={this.handelFileChange} style={{ paddingTop: '6px', paddingLeft: '10px' }} />
                                </Col>
                            </Row>
                        </div>
                        <div className="card-footer">
                            <button className="btn btn-primary" onClick={this.handleSubmit}> {this.state.ButtonText} </button>
                            <button className="btn btn-dark m-l-10" onClick={this.handleCancel}>Cancel</button>
                        </div>
                    </div>
                </div>

            </div>

        );
    }
}
